import React from 'react'

import { LntEmpty, LntFormItem, LntSelect, LntTextArea } from '@app/components/base'
import { Switch } from '@app/components/util'

import { FILTERS_PLACEHOLDERS } from '@app/constants/filters'
import { SIZE } from '@app/constants'
import { COMMENT_SAMPLES } from '@app/constants/queryKeys'

import { getTemplates } from '@app/api/routes/templates'

import { getFilterTemplatesFromEntities } from '@app/utils/entitiesAdapters'

import { CommentsItemWithSamples } from '@app/components/ActivityFeed/tabs/components/CommentsItem'

import styles from '../styles.module.scss'

import type { CommentsTabWithSamplesProps } from './types'

const { Case } = Switch

export const CommentsTabWithSamples: React.FC<CommentsTabWithSamplesProps> = props => {
  const { data, onDeleteComment, onPatchComment } = props

  return (
    <div>
      <div className={ styles.commentsTab__newComment }>
        <LntFormItem
          name='sampleIds'
          defaultValue={ [] }
          label='Комментарий'
        >
          <LntSelect
            mode='multiple'
            showArrow
            placeholder={ FILTERS_PLACEHOLDERS.samples }
            querySelect={ {
              queryKey: [COMMENT_SAMPLES.commentSamplesItems],
              queryFn: getTemplates,
              select: getFilterTemplatesFromEntities
            } }
          />
        </LntFormItem>
        <LntFormItem
          name='message'
          label='Дополнительный комментарий'
        >
          <LntTextArea
            showCount
            maxLength={ 250 }
            size={ SIZE.large }
            placeholder={ FILTERS_PLACEHOLDERS.comment }
          />
        </LntFormItem>
      </div>

      <div className={ styles.ommentsTab__commentsList }>
        <Switch fallback={ <LntEmpty description='Комментариев пока нет' /> }>
          <Case condition={ !!data?.length }>
            { data?.map(item => (
              <CommentsItemWithSamples
                key={ item.id }
                data={ item }
                onDeleteComment={ onDeleteComment }
                onPatchComment={ onPatchComment }
              />
            )) }
          </Case>
        </Switch>
      </div>
    </div>
  )
}
